import PropTypes from 'prop-types'
import React, { Component } from 'react'
import CONSTANTS from '../../constants/index'
import { PASSWORD_UPDATE_PENDING } from '../../actions/index'
import '../sign-up/sign-up.css'

export default class ChangePassword extends Component {
  constructor(props) {
    super(props)

    this.state = {
      errorNotEq: false,
      errorPass: false,
      password: '',
      newPassword: '',
      confirmPassword: '',
    }
  }

  passwordHandler = (e) => {
    this.setState({password: e.target.value})
  }

  newPasswordHandler = (e) => {
    this.setState({
      newPassword: e.target.value,
      errorNotEq: false,
    })
  }

  confirmPasswordHandler = (e) => {
    this.setState({
      confirmPassword: e.target.value,
      errorNotEq: false,
    })
  }

  savePassword = (e) => {
    e.preventDefault()

    if ((this.state.newPassword.length < CONSTANTS.AUTH_MIN_PASSWORD_LENGTH) || (this.state.newPassword.length > CONSTANTS.AUTH_MAX_PASSWORD_LENGTH)) {  
      this.setState({ errorPass: true })
    } else if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({ errorNotEq: true })
    } else {
      this.props.handleAction(PASSWORD_UPDATE_PENDING, {
        password: this.currentPassword.value,
        newPassword: this.newPassword.value,
      })
    }
  }

  render() {
    const { t } = this.props

    return (
      <form onSubmit={this.savePassword}>
        <div className="subtitle xs-text-7 xs-text-gray xs-mb5 xs-mt3 xs-mb4">
          {t('PASSWORD_BELOW')}
        </div>

        <input
          type="password"
          ref={(c) => { this.currentPassword = c }}
          className={`xs-py3 xs-mb0 sign-with email xs-py3 xs-fit text-input xs-border-bottom-none ${this.state.errorPass && 'error-input'}`}
          placeholder={t('CURRENT_PASSWORD')}
          autoComplete="current-password"
          onChange={this.passwordHandler}
        />
        <input
          type="password"
          ref={(c) => { this.newPassword = c }}
          className={`xs-py3 xs-mb0 sign-with email xs-py3 xs-fit text-input xs-border-bottom-none ${this.state.errorNotEq && 'error-input'}`}
          placeholder={t('NEW_PASSWORD')}
          autoComplete="new-password"
          onChange={this.newPasswordHandler}
        />
        <input
          type="password"
          className={`xs-py3 xs-mb0 sign-with email xs-py3 xs-fit text-input ${this.state.errorNotEq && 'error-input'}`}
          placeholder={t('REPEAT_PASSWORD')}
          autoComplete="new-password"
          onChange={this.confirmPasswordHandler}
        />

        {this.state.errorNotEq &&
          <p className="xs-text-red xs-mt1 xs-text-left">{t('ACCOUNT_PASSWORDS_VALIDATION')}</p>
        }

        {this.state.errorPass &&
          <p className="xs-text-red xs-mt1 xs-text-left">{t('ERROR_PASSWORD_LENGTH')}</p>
        }

        {this.props.updated &&
          <p className="xs-mt3">{t('PASSWORD_UPDATE_SUCCESS')}</p>
        }

        <button type="submit" className="xs-fill-blue-cta rounded xs-border-none cond caps xs-text-white xs-py3 xs-col-12 xs-mt4">{t('SAVE_CHANGES')}</button>
      </form>
    )
  }
}

ChangePassword.propTypes = {
  t: PropTypes.func.isRequired,
  handleAction: PropTypes.func.isRequired,
  updated: PropTypes.bool,
}

ChangePassword.defaultProps = {
  updated: false,
}




// WEBPACK FOOTER //
// ./src/components/account-details/change-password.js